import React, { useEffect, useState } from "react";
import PageHero from "@/components/PageHero";
import PageMeta from "@/components/PageMeta";
import StandingsTable from "@/components/StandingsTable";
import { api } from "@/lib/api";

export default function Standings() {
  const [standings, setStandings] = useState([]);
  const [teams, setTeams] = useState([]);
  useEffect(() => {
    api.get("/standings").then((r) => setStandings(r.data)).catch(() => {});
    api.get("/teams").then((r) => setTeams(r.data)).catch(() => {});
  }, []);
  const bySlug = Object.fromEntries(teams.map((t) => [t.slug, t]));

  return (
    <div>
      <PageMeta
        title="Standings — PSHL8 League Table"
        description="Live league standings, points, form and head-to-head across all 8 PSHL8 franchises."
        image="/api/og/standings/og-image.png"
      />
      <PageHero
        overline="League Table"
        title={<>Standings.</>}
        subtitle="Current league standings across all PSHL8 franchises."
        bgImage="https://images.pexels.com/photos/6468938/pexels-photo-6468938.jpeg"
      />
      <section className="section pt-0">
        <div className="pshl-container">
          <StandingsTable standings={standings} teamsBySlug={bySlug} />
        </div>
      </section>
    </div>
  );
}
